import Tag from "@/components/Tag";
import { getActiveBackendSource, getBackendSourceLabel, isBackendSourceToggleAvailable } from "@/lib/backendSource";

export default function BackendSourceIndicator() {
  if (!isBackendSourceToggleAvailable()) return null;

  const source = getActiveBackendSource();
  const label = getBackendSourceLabel(source);
  const isLocalhost = source === "localhost";

  return (
    <Tag
      size="small"
      compact
      tagType={isLocalhost ? "warn" : "information"}
      tagStyle="standard"
      iconName={isLocalhost ? "computer" : "cloud"}
      title={`API backend: ${label}`}
      testId="backend-source-indicator"
    >
      {label}
    </Tag>
  );
}
